import UserRoleCommentTypeResolver from '@ui/comments/comments-views/user-role-comment-type-resolver';
import CommentView from '@ui/comments/comment-view';
import VisibleDeletedCommentView from '@ui/comments/comments-views/visible-deleted-comment-view';
import ModerationDeletedCommentView from '@ui/comments/comments-views/moderation-deleted-comment-view';
import FlaggedCommentView from '@ui/comments/comments-views/flagged-comment-view';

export default class CommentFactory {
  static create(model) {
    switch(UserRoleCommentTypeResolver.determineType(model)) {
      case 'REGULAR_COMENT':
        return new CommentView(model);

      case 'FLAGGED_COMMENT':
        return new FlaggedCommentView(model);

      case 'VISIBLE_DELETED':
        // Return template with [ Komentarz został usunięty ]
        return new VisibleDeletedCommentView(model);

      case 'MODERATION_DELETED':
        // Deleted comments seen in moderation mode
        return new ModerationDeletedCommentView(model);

      default:
        return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/CommentFactory.js